import {
  COLOR_GRAY_100,
  COLOR_GRAY_200,
  COLOR_GRAY_300,
  COLOR_GRAY_400,
  COLOR_GRAY_500,
  COLOR_GRAY_600,
  COLOR_GRAY_700,
  COLOR_GRAY_800,
  COLOR_GRAY_900,
} from '@/styles/palette';

export const ALL_GRAYS = [
  COLOR_GRAY_100,
  COLOR_GRAY_200,
  COLOR_GRAY_300,
  COLOR_GRAY_400,
  COLOR_GRAY_500,
  COLOR_GRAY_600,
  COLOR_GRAY_700,
  COLOR_GRAY_800,
  COLOR_GRAY_900,
];
